import { render, staticRenderFns } from "./modules__order.vue?vue&type=template&id=0297db60"
import script from "./modules__order.vue?vue&type=script&lang=js"
export * from "./modules__order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports